import moment from "moment";
import { formatDate, formatDateTime } from "../appconfig/AppHelper";
import { Avatar } from "primereact/avatar";

export const formatPageDate = function (date: any) {
  return date ? moment.utc(date).format("DD MMM YYYY") : null;
};

// title template image with name for details
export const titleTemplate = (rowData: any) => {
  return (
    <div className="flex gap-1 avatar-div align-items-center">
      {!window.cn(rowData?.img) ? (
        <Avatar style={{ flex: "0 0 auto" }} image={rowData?.img} shape="circle" />
      ) : (
        <Avatar icon="pi pi-user" shape="circle" />
      )}
      <div className="ml-2 emp-name link-name">{rowData.title}</div>
    </div>
  );
};

// name template
export const nameTemplate = (rowData: any) => {
  return (
    <div className="name">
      {rowData.first_name} {rowData.last_name}
    </div>
  );
};

// wage template
export const wageBodyTemplate = (rowData: any) => {
  return <div className="name">${rowData.wage}</div>;
};

// holiday name template
export const holidayNameTemplate = (rowData: any) => {
  return <div className="name">{rowData.name}</div>;
};

// employee name template
export const employeeNameTemplate = (rowData: any) => {
  return (
    <div className="name">
      {rowData.employee_data.first_name} {rowData.employee_data.last_name}
    </div>
  );
};

// user name template
export const userTemplate = (user: any) => {
  return user ? (
    <div className="name">
      {user.first_name} {user.last_name}
    </div>
  ) : (
    ""
  );
};

// address template
export const addressTemplate = (rowData: any) => {
  return (
    <div>
      {rowData.address} {rowData.city} {rowData.province} {rowData.postal_code}
    </div>
  );
};

// payperiod Start And End date
export const payPeriodTemplate = (rowData: any) => {
  return (
    <div className="name">
      {formatDate(rowData.start_date)} - {formatDate(rowData.end_date)}
    </div>
  );
};

// date dynamic template
export const dateTemplate = (rowData: any, rowIndex: any) => {
  const value = rowData[rowIndex.field];
  return <div>{value ? formatDate(value) : "-"}</div>;
};

// date time dynamic template
export const dateTimeTemplate = (rowData: any, rowIndex: any) => {
  return (
    <>
      <div>{formatDateTime(rowData[rowIndex.field])}</div>
    </>
  );
};

// return month from date
export const monthTemplate = (rowData: any) => {
  const apiDate = rowData?.pay_check_date;
  if (!apiDate) {
    return "-";
  } else {
    const monthName = moment(apiDate).format("MMMM");
    return (
      <>
        <div>{monthName}</div>
      </>
    );
  }
};

// amount (wage) in $
export const amountTemplate = (rowData: any) => {
  return rowData ? (
    <>
      <div>
        <span>{rowData.amount ? `$${rowData.amount}` : "-"}</span>
      </div>
    </>
  ) : (
    "-"
  );
};

// pdf created date time
export const createdAtTemplate = (rowData: any) => {
  return (
    <>
      <div>{formatDateTime(rowData?.createdAt)}</div>
    </>
  );
};

//Empty Temlate for image upload
export const emptyTemplate = (rowData: any) => {
  return <div className="flex align-items-center flex-column">{rowData?.pay_period ? rowData?.pay_period : "-"}</div>;
};
